<template>
  <div class="recent" :class="isCollapse ? 'recent-collapse' : ''">
    <div>
      <home-block
        blockIndex="01"
        :blockTitle="$router.lang.get('最新消息')"
        blockTitleEng="NEWS"
        :link="links[currentTab]"
      >
        <div
          class="recent-container"
          :class="
            isCollapse
              ? 'full-collapse'
              : screenState.screenWidth > 1240
              ? ''
              : 'collapse'
          "
        >
          <div v-if="!isCollapse" class="home-recent-tab">
            <pang-tab :tabs="tabs" v-model:current="currentTab" />
            <div class="home-recent-more" @click="goto(links[currentTab])">
              +
            </div>
          </div>
          <transition name="tab">
          <div class="article-content">
            <div v-if="data.length > 0" class="newest">
              <div>{{ $router.lang.get("最新") }}</div>
              <i></i>
              <div
                class="article-title"
                @click="gotoRecent(data[0])"
                :title="data[0].article.title"
              >
                [{{ RECENT_TYPES[data[0].recent_type] }}]
                {{ data[0].article.title }}
              </div>
            </div>
            <div
              class="article-container"
              v-for="recent in data"
              :key="recent.id"
            >
              <div
                class="article-title"
                :class="recent.active ? 'article-active' : ''"
                @mouseover="activate(recent)"
                @mouseleave="deactivate(recent)"
                @click="gotoRecent(recent)"
                :title="recent.article.title"
              >
                [{{ RECENT_TYPES[recent.recent_type] }}]
                {{ recent.article.title }}
              </div>
              <div>{{ recent.create_at.substr(0, 10) }}</div>
            </div>
          </div>
          </transition>
        </div>
      </home-block>
      <div
        v-if="!isCollapse"
        class="banner-container"
        :class="screenState.screenWidth > 768 ? '' : 'banner-collapse'"
      >
        <pang-banner
          :images="banners"
          :interval="4000"
          :height="screenState.screenWidth > 768 ? '33.4375vw' : '52vw'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { PangTab, PangBanner } from "../../../components";
import enums from "../../../utils/enums.js";
import request from "../../../api/request";
import { useScreenState } from "../../../store";
import HomeBlock from "./HomeBlock";
import message from "../../../utils/message";
import browser from '../../../utils/browser';

export default {
  name: "Recent",
  components: {
    PangTab,
    PangBanner,
    HomeBlock,
  },
    props: {
        banners: {
            type: Array,
            required: true,
        },
    },
  data() {
    return {
      screenState: useScreenState(),
      // 这里是更新官网活动滚图，链接需要後加，移动端不显示
      bannerImages: [
        {
          pc: require("../../../assets/images/img_event_banner_01.jpg"),
          href: "/recent/notice/1",
        },
        {
          pc: require("../../../assets/images/img_event_banner_02.jpg"),
          href: "/recent/notice/1",
        },
        {
          pc: require("../../../assets/images/img_event_banner_03.jpg"),
          href: "/recent/notice/1",
        },
      ],
      tabs: [
        this.$router.lang.get("綜合"),
        this.$router.lang.get("公告"),
        this.$router.lang.get("活動"),
        this.$router.lang.get("更新"),
      ],
      links: [
        "/recent",
        "/recent/notice",
        "/recent/activity",
        "/recent/update",
      ],
      data: [],
      RECENT_TYPES: enums.RECENT_TYPES,
      currentTab: 0,
    };
  },
  computed: {
    isCollapse() {
      return this.screenState.screenWidth < 900;
    },
  },
  methods: {
    goto(href) {
      this.$router.push(href);
    },
    gotoRecent(recent) {
      let url = this.links[recent.recent_type] + "/" + recent.id;
      if (browser.isPc)
          window.open(url)
      else
          this.$router.push(url)
    },
    activate(recent) {
      recent.active = true;
    },
    deactivate(recent) {
      recent.active = false;
    },
    get_recents(currentTab) {
      let _this = this;
      let params = {};
      if (currentTab > 0) params["recent_type"] = currentTab;
      request.get("/recents", params, this).then(function (res) {
        if (res.status == 200) {
          _this.data = res.data.results;
        } else {
          message.resMessage(res, _this);
        }
      });
    },
  },
  mounted() {
    this.get_recents(this.currentTab);
  },
  watch: {
    currentTab(val) {
      this.get_recents(val);
    },
  },
};
</script>

<style>
.tab-enter-active,.tab-leave-active{
    transition:all 1s ease;
}

.banner-container .butt {
  /* position: relative; */
  display: block;
  height: inherit;
  width: 22px;
  margin-top: 9px;
}

.banner-container .pang-banner {
  /* width: 468px; */
  width: 25.5208vw;
  height: 33.4375vw;
  /* max-height: 642px; */
  display: flex;
}

.banner-collapse .pang-banner {
  width: calc(90vw - 580px);
}

.banner-container .butt > div {
  padding: 5.5px 11px;
}

.banner-container .butt-item {
  height: 12px;
  width: 12px;
}

.home-recent-tab {
  border-bottom: 1px solid #757575;
  display: flex;
}
.home-recent-tab > .pang-tab {
  font-size: 1.2vw;
  color: #ffffff;
}

.home-recent-tab > .pang-tab > div {
  line-height: 39px;
  padding: 0 2px;
  margin-right: 30px;
  width: inherit;
}

.home-recent-tab > .pang-tab .inactive {
  color: #ffffff;
}

.home-recent-tab > .pang-tab .active {
  color: #ffffff;
  border-bottom: 2px solid #c6a86c;
}

.home-recent-more {
  margin-left: auto;
  font-size: 20px;
  width: 26px;
  height: 26px;
  border: 1px solid #ffffff;
  border-radius: 50%;
  line-height: 23px;
  text-align: center;
  margin-top: 5px;
  cursor: pointer;
}
</style>

<style scoped>

.recent {
  height: 48.5vw;
}
.recent > div {
  max-width: calc(72vw + 200px);
  margin: 0 auto;
  width: 80vw;
  padding-top: calc(96 / 1920 * 100vw);
  display: flex;
  justify-content: space-around;
}

.recent-collapse {
  background-color: #10100f;
}

.recent-container {
  width: 34vw;
  background: rgba(41, 38, 38, 0.51);
  padding: 1vw;
  margin: 1vw;
}

.collapse {
  width: 380px;
}

.full-collapse {
  max-width: none;
  width: calc(90vw - 45px);
  margin-left: 0;
  padding: 10px 20px 7px 25px;
}

.article-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.article-active {
  color: #c6a86c;
}

/* 轮播 */
/* .banner-container {
  width: 25.5208vw;
  height: 33.4375vw;
} */

.banner-collapse {
  width: calc(90vw - 558px);
  margin-top: 35px;
}

.newest,
.article-container {
  display: flex;
}

.newest {
  width: 100%;
  height: 38px;
  line-height: 38px;
  background: #3a3a3a;
  margin: 10px 0 16px 0;
  font-size: 1vw;
}

@media screen and (min-width: 1920px) {
  .newest {
    font-size: 18px;
  }
}

.newest > div:first-child {
  width: 42px;
  background-color: #c6a86c;
  text-align: center;
}

.newest > i {
  margin: auto 16px auto 0px;
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-left: 6px solid #c6a86c;
  border-bottom: 6px solid transparent;
}

.newest > div:last-child {
  color: #fff;
}

.recent-collapse .newest {
  font-size: calc(0.5vw + 9px);
}

.article-container {
  line-height: 22px;
  padding: 5px 0;
  font-size: 1vw;
  font-weight: 400;
  width: 100%;
  color: #cccccc;
}

@media screen and (min-width: 1920px) {
  .article-container {
    line-height: 18px;
    font-size: 18px;
  }
}

.article-container > div:first-child {
  width: calc(100% - 90px);
}

.article-container > div:last-child {
  margin-left: auto;
  width: 7vw;
}

.recent-collapse {
height: calc(10vw + 400px);
}

.recent-collapse .article-container {
  font-size: calc(0.5vw + 9px);
}

.recent-collapse .article-container > div:last-child {
  min-width: 80px;
}

</style>
